module.exports = __webpack_public_path__ + "75bbea4a34d6559b159ad089d9f554b7.png";